import { Typography, Button, palette } from "@powerdiary/components-library/lib";
import { Box } from "@mui/material";
import { useAnalytics } from "../../../hooks/useAnalytics";

export default function ConnectionTestSection() {
    const { track } = useAnalytics();

    const openTestCallUri = () => {
        track("telehealth_test_connection_clicked");
        window.open("https://zoom.us/test", "_blank", "noopener,noreferrer");
    };

    return (
        <Box>
            <Box marginBottom="8px">
                <Typography
                    variant="paragraphMediumRegular"
                    color={palette.neutral["700"]}
                    data-test-id="text_test_internet_connection"
                >
                    Test your internet connection, video and audio by joining a test meeting.
                </Typography>
            </Box>
            <Button variant="outlined" onClick={openTestCallUri} data-test-id="button_start_test_meeting">
                START A TEST MEETING
            </Button>
        </Box>
    );
}
